/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import type { ContentService } from '@oneaudi/content-service';
import type { GfaLocaleServiceV1 } from '@volkswagen-onehub/gfa-locale-service';
import type { EnvConfigServiceV1 } from '@volkswagen-onehub/audi-env-config-service/dist/v1/EnvConfigServiceV1';
// eslint-disable-next-line
import { VueFormatterServiceInterfaceV1 } from '@oneaudi/vue-formatter-service';
import type { AudiFootnoteRefernceServiceScopeManagerInterfaceV3 } from '@oneaudi/footnote-reference-service';
import { ContentContext } from './ContentContext';
import mapContent from '../contentMapping/contentMapping';

export const ContextProvider: React.FC<{
  featureAppId: string;
  children?: React.ReactNode;
  contentService: ContentService;

  envConfigService: EnvConfigServiceV1;
  localeService: GfaLocaleServiceV1;
  loggerService: any;
  footnoteReferenceService: AudiFootnoteRefernceServiceScopeManagerInterfaceV3;
  // vueFormatterService: VueFormatterFeatureServiceInterfaceV1; // TODO: Confirm the below is the correct replacement
  vueFormatterService: VueFormatterServiceInterfaceV1;
}> = ({
  featureAppId,
  vueFormatterService,
  contentService,
  localeService,
  loggerService,
  footnoteReferenceService,
  children,
}) => {
  const [rawContent, setRawContent] = React.useState<any>(contentService?.getContent());

  let content = null;

  React.useEffect(() => {
    const listener = () => {
      setRawContent(contentService?.getContent());
    };
    contentService?.onContentChange(listener);

    return () => {
      contentService?.removeOnContentChange(listener);
    };
  }, [contentService]);

  content = mapContent(rawContent);

  return (
    <ContentContext.Provider
      value={{
        content,
        footnoteReferenceService,
        featureAppId,
        vueFormatterService,
        localeService,
        loggerService,
      }}
    >
      {children}
    </ContentContext.Provider>
  );
};

ContextProvider.displayName = 'ContextProvider';
